/**
 * Feature Flags Module
 *
 * Unified interface for checking feature flags via Unleash.
 *
 * - The value comes from Unleash. If the Unleash server is unreachable,
 *   the SDK returns cached values; unknown flags remain `false`.
 */

import { useFlag as useUnleashFlag } from "@unleash/proxy-client-react";

import { FeatureFlagProvider } from "./FeatureFlagProvider";
import type { FeatureFlagName } from "./types";
import { UNLEASH_CLIENT } from "./unleash";

export type { FeatureFlagName } from "./types";
export { FeatureFlags } from "./types";
export {
  UnleashContextSync,
  useUnleashContextStatus,
} from "./UnleashContextSync";
export { UNLEASH_CLIENT, UNLEASH_CONFIG, UNLEASH_CONFIGURED } from "./unleash";
export {
  type AdvancedTradingDashboardAccessStatus,
  useAdvancedTradingDashboardAccess,
} from "./useAdvancedTradingDashboardAccess";
export { FeatureFlagProvider };

export const isFeatureEnabled = (flagName: FeatureFlagName): boolean =>
  UNLEASH_CLIENT?.isEnabled(flagName) ?? false;

/**
 * React hook for checking if a feature is enabled.
 */
export const useFeatureEnabled = (flagName: FeatureFlagName): boolean =>
  useUnleashFlag(flagName);
